module.exports = __webpack_public_path__ + "img/BSA.1bb49231.png";